import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import loadable from "@loadable/component";

import gameImg1 from "../../assets/images/games/samplegameImg.png";
import { GetSectionGamesAction } from "../../redux/actions/homeActions";
import { getCloudFrontSourcePath, getCategoryDetailsById } from "../../utils/functions";
import { usePageMeta } from "../../utils/pageMeta";

const Loader = loadable(() => import("../../components/UI/Loader"));
const GameCard = loadable(() => import("../../components/UI/GameCard"));
const GameGridWithAd = loadable(() => import("../../components/UI/GameGridWithAd"));
const AdBanner = loadable(() => import("../../components/UI/AdBanner"));

const ViewAllGames = () => {
  const HomeState = useSelector((state) => state.Home);
  const CategoryState = useSelector((state) => state.Category);
  const dispatch = useDispatch();
  const { sectionId } = useParams();
  const { activeSectionViewAll, sectionLoading } = HomeState;
  const { allCategoryData } = CategoryState;

  useEffect(() => {
    dispatch(GetSectionGamesAction({ section_id: sectionId }));
  }, [sectionId, dispatch]);

  let sectionGamesList = [],
    sectionData = [];
  let sectionDataIndex = activeSectionViewAll.findIndex(
    (x) => x.id === Number(sectionId)
  );
  if (sectionDataIndex >= 0) {
    sectionData = activeSectionViewAll[sectionDataIndex];
    if (sectionData) {
      sectionGamesList = sectionData?.items ? sectionData?.items : [];
    }
  }
  
  // Hide items that don't have a known category (getCategoryDetailsById returns "-")
  if (sectionGamesList && sectionGamesList.length > 0) {
    sectionGamesList = sectionGamesList.filter((g) => getCategoryDetailsById(g?.categoryId, allCategoryData) !== "-");
  }
  usePageMeta({
    title: sectionData?.title ? `${sectionData.title} - Free Online Games | Akedo` : "",
    description: sectionData?.title ? `Play ${sectionData.title.toLowerCase()} for free on Akedo, right in your browser. No downloads needed.` : "",
    path: `/view-all/${sectionId}`,
  });
  let cloudFrontSourcePath = getCloudFrontSourcePath();

  return (
    <>
      {sectionLoading?.[sectionId] && sectionDataIndex < 0 && <Loader isTranserent={true} />}
      <section className="viewAllGame gridPageContent px-0 py-[30px]">
        <div className="container">
          <div className="text-center miniLayoutTilte">
            {" "}
            <h1 className="text-[#fff] text-[32px] tracking-wide   view-all-title">
              {" "}
              {sectionData?.title}{" "}
            </h1>{" "}
          </div>
          <GameGridWithAd
            items={sectionGamesList || []}
            renderItem={(val, index) => (
              <GameCard
                keyIndex={`game_id_${index}`}
                img={
                  val?.icon ? `${cloudFrontSourcePath}${val?.icon}` : gameImg1
                }
                game={val}
                key={`view_allgames_${index}`}
                subtitle={getCategoryDetailsById(val?.categoryId, allCategoryData)}
              />
            )}
          />
          {sectionGamesList.length > 0 && <AdBanner key={sectionId} placement="grid-bottom" />}
        </div>
      </section>
    </>
  );
};

export default React.memo(ViewAllGames);
